import styled from "@emotion/styled";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

export const StyledScrollContainer = styled(MKBox)(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  scrollBehavior: "smooth",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  padding: "1rem 0rem",
  scrollSnapType: "x mandatory",
  WebkitOverflowScrolling: "touch",
  justifyContent: "flex-start",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyledCardWrapper = styled(MKBox)(({ theme }) => ({
  minWidth: "325px !important",
  margin: "1rem 1rem",
  transition: "all 0.3s ease",
  scrollSnapAlign: "center",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.059)",
  },
  [theme.breakpoints.up("md")]: {
    minWidth: "350px !important",
  },
}));

export const StyledTitleOverlay = styled(MKBox)(({ theme }) => ({
  position: "absolute",
  bottom: "10px",
  left: 0,
  right: 0,
  background: "linear-gradient(transparent, rgba(0,0,0,.8))",
  padding: "2rem 1rem 1rem 1rem",
  borderRadius: "1rem",
}));

export const StyledTitleText = styled(MKTypography)(({ theme }) => ({
  fontWeight: 800,
  lineHeight: 1.3,
  color: "white !important",
  textAlign: "center",
  textShadow: "0 1px 3px rgba(0,0,0,.5)",
  margin: 0,
}));

export const StyledLeftGradient = styled(MKBox)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: "-0.5rem",
  bottom: 0,
  width: "2rem",
  pointerEvents: "none",
  zIndex: 1,
}));

export const StyledRightGradient = styled(MKBox)(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: "-0.5rem",
  bottom: 0,
  width: "2rem",
  background: "linear-gradient(to left, white, transparent)",
  pointerEvents: "none",
  zIndex: 1,
}));
